const FORCE_RELOAD_CHECK_TIME = 60_000;
const IDLE_TIME = 1000 * 60 * 60; // 60 MIN  IDEAL TIME OUT
const KEY = 'key';
const POS_ID = 'pos_id';
const POS_NAME = 'pos_name';
const DUMMY_ITEM = 'dummy_item';
const ID = 'id';
const MAX_CART_ITEM_QUANTITY = 19;
const RESET_HEALTH_STATUS_ONCLOSE_DELAY = 1000;
const TASKROUTER_WSLINK = 'TASK_CHANNEL';
const TASKROUTER_RECONNECT_ATTEMPTS = 5;
const TASKROUTER_RECONNECT_INTERVAL = 5000;
const TIMEOUT = 5000;
const ORDER_STATUS_ICON_RESET_INTERVAL = 3000;
const SHOW_AI_ESCALATION_INTERVAL = 5000;
const OUT_OF_SESSION = 'out of session';
const AUTH_TOKEN_RESPONSE_HEADER = 'x-presto-auth-token';
const AGENT_INTERCEPTION_CONFIRM_CONTENT =
  'AI is ON: Would you like to intercept/take over this order?';
const AUDIO_WS_PATH = '/audio';
const UNLEASH_POLL_INTERVAL = 15; // in seconds
const UNLEASH_APP_NAME = 'HITL';
const DUMMY_RESTAURANT_CODE = 'dummy_restaurant_code';
const A_LA_CARTE_POS_ID = 'a_la_carte_pos_id';
const TTS_PROMPT = '/tts-prompt';
const TTS_PROMPT_PREFIX = 'tts-prompt';
const UPSELL = '/upsell';
const UPSELL_PREFIX = 'upsell';
const OTEL_APP_NAME = 'hitl';
const OTEL_METRIC_HEALTH = 'hitl-health-score';
const AUTO_COMBOS = 'Auto Combos';
const UPSELL_METRIC_VERSION = '1';
const FULL_WEEKDAY_FORMAT = 'dddd';
const UPGRADE = '/upgrade';
const UPGRADE_PREFIX = 'upgrade';
const IP_CHECK_FAILED_MESSAGE =
  'Login restricted: Unauthorized network. Contact your supervisor for assistance.';
const COUPON_LENGTH = 6;
const LOYALTY_LENGTH = 10;
const AMOUNT_DEFAULTER = '--';
const COMBO_SIZE_MODIFIER_NAME_PREFIX = 'combo_size';
const ALL_ENTRIES = '**all**';
const TOTAL_PLACEHOLDER = '{total}';
const TOTAL_READBACK_CONSTRAINT_PREFIX = 'total_readback';

export {
  AGENT_INTERCEPTION_CONFIRM_CONTENT,
  AUDIO_WS_PATH,
  AUTH_TOKEN_RESPONSE_HEADER,
  DUMMY_ITEM,
  DUMMY_RESTAURANT_CODE,
  FORCE_RELOAD_CHECK_TIME,
  ID,
  IDLE_TIME,
  KEY,
  MAX_CART_ITEM_QUANTITY,
  ORDER_STATUS_ICON_RESET_INTERVAL,
  OUT_OF_SESSION,
  POS_ID,
  POS_NAME,
  RESET_HEALTH_STATUS_ONCLOSE_DELAY,
  SHOW_AI_ESCALATION_INTERVAL,
  TASKROUTER_RECONNECT_ATTEMPTS,
  TASKROUTER_RECONNECT_INTERVAL,
  TASKROUTER_WSLINK,
  TIMEOUT,
  UNLEASH_APP_NAME,
  UNLEASH_POLL_INTERVAL,
  A_LA_CARTE_POS_ID,
  TTS_PROMPT,
  TTS_PROMPT_PREFIX,
  UPSELL,
  UPSELL_PREFIX,
  UPGRADE,
  UPGRADE_PREFIX,
  OTEL_APP_NAME,
  OTEL_METRIC_HEALTH,
  AUTO_COMBOS,
  UPSELL_METRIC_VERSION,
  FULL_WEEKDAY_FORMAT,
  IP_CHECK_FAILED_MESSAGE,
  COUPON_LENGTH,
  LOYALTY_LENGTH,
  AMOUNT_DEFAULTER,
  COMBO_SIZE_MODIFIER_NAME_PREFIX,
  ALL_ENTRIES,
  TOTAL_PLACEHOLDER,
  TOTAL_READBACK_CONSTRAINT_PREFIX,
};
